/* eslint no-barrel-files/no-barrel-files: off -- Alloy's synchronous dynamic transform requires direct named exports from this shared chunk. */
import {CodeViewBlameEntrypoint} from '../pages/CodeViewBlameEntrypoint'
import {CodeViewBlobEntrypoint} from '../pages/CodeViewBlobEntrypoint'
import {CodeViewBlobLayout} from '../pages/CodeViewBlobLayout'
import {CodeViewBlobLayoutErrorBoundary} from '../pages/CodeViewBlobLayoutErrorBoundary'
import {CodeViewDeleteEntrypoint} from '../pages/CodeViewDeleteEntrypoint'
import {CodeViewEditEntrypoint} from '../pages/CodeViewEditEntrypoint'
import {CodeViewFileTreeLayout} from '../pages/CodeViewFileTreeLayout'
import {CodeViewLayout} from '../pages/CodeViewLayout'
import {CodeViewNewEntrypoint} from '../pages/CodeViewNewEntrypoint'
import {CodeViewRepoEntrypoint} from '../pages/CodeViewRepoEntrypoint'
import {CodeViewTreeDeleteEntrypoint} from '../pages/CodeViewTreeDeleteEntrypoint'
import {CodeViewTreeEntrypoint} from '../pages/CodeViewTreeEntrypoint'
import {CodeViewTreeErrorBoundary} from '../pages/CodeViewTreeErrorBoundary'
import type {CodeViewRouteComponents} from './create-code-view-routes'

export {
  CodeViewBlameEntrypoint,
  CodeViewBlobEntrypoint,
  CodeViewBlobLayout,
  CodeViewBlobLayoutErrorBoundary,
  CodeViewDeleteEntrypoint,
  CodeViewEditEntrypoint,
  CodeViewFileTreeLayout,
  CodeViewLayout,
  CodeViewNewEntrypoint,
  CodeViewRepoEntrypoint,
  CodeViewTreeDeleteEntrypoint,
  CodeViewTreeEntrypoint,
  CodeViewTreeErrorBoundary,
}

export const codeViewRouteComponents = {
  CodeViewBlameEntrypoint,
  CodeViewBlobEntrypoint,
  CodeViewBlobLayout,
  CodeViewBlobLayoutErrorBoundary,
  CodeViewDeleteEntrypoint,
  CodeViewEditEntrypoint,
  CodeViewFileTreeLayout,
  CodeViewLayout,
  CodeViewNewEntrypoint,
  CodeViewRepoEntrypoint,
  CodeViewTreeDeleteEntrypoint,
  CodeViewTreeEntrypoint,
  CodeViewTreeErrorBoundary,
} satisfies CodeViewRouteComponents
